import { LIST_FEATURE_FLAGS, useFeatureFlag } from '@diamond/shared/utils';

/**
 * Master gate for the promo + voucher preview shown in the add-to-cart popup
 * and the product detail order counter. When off, neither the "Solusi Hemat"
 * promo section nor the "Voucher Tersedia" voucher section is rendered (and the
 * voucher eligibility list is not fetched).
 */
export function usePromoVoucherPreviewEnabled(): boolean {
  return useFeatureFlag(LIST_FEATURE_FLAGS.FF_PROMO_VOUCHER_PREVIEW, false);
}
